module.exports = __webpack_public_path__ + "static/media/reprimands.b241324f.svg";